// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { utils } from '@seedplanner/shared-utils';
import dayjs from 'dayjs';
import timezoneDayJs from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezoneDayJs);

export const getTimeRanges = (timezone: string) => {
  const now = dayjs().tz(timezone);
  const sevenDaysFromTodayEnd = now.add(7, 'day').endOf('day').unix();
  const sevenDaysFromTodayStart = now.add(7, 'day').startOf('day').unix();

  return {
    todayStart: utils.todayStart(timezone).unix(),
    todayEnd: utils.todayEnd(timezone).unix(),
    todayStartDate: utils.todayStart(timezone),
    todayEndDate: utils.todayEnd(timezone),
    sevenDaysFromTodayStart,
    sevenDaysFromTodayEnd,
  };
};
